module.exports = __webpack_public_path__ + "media/images/demo/email-b0b64448ea390803253a0e6198f04c74.jpg";